import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Auth from "./layouts/Auth";
import Login from "./pages/Login";
import Dashboard from "./layouts/Dashboard";
import Home from "./pages/Home";
import PushNotification from "./pages/PushNotification";
import EntryAccess from "./pages/EntryAccess";
import ManageMerchant from "./pages/ManageMerchant";
import Merchant from "./pages/Merchant";
import Customer from "./pages/Customer";
import { UserContext } from "./contexts/UserContext";
import TopUpTransactions from "./pages/TopUpTransactions";
import Report from "./pages/Report";
import ReportMerchant from "./pages/ReportMerchant";
import PhysicalCard from "./pages/PhysicalCard";
import { LoadContext } from "./contexts/LoadContext";
import { Loader } from "./components/Loader";
import NotFound from "./pages/NotFound";
import { toast } from "react-toastify";
import { ToastMessage } from "./components/ToastMessage";
import Dispute from "./pages/Dispute";
import Events from "./pages/Events";
import CreateEvent from "./pages/CreateEvent";
import ManageOutlet from "./pages/ManageOutlet";
import AddOutlet from "./pages/AddOutlet";
import AlMahaDrive from "./pages/AlMahaDrive";
import CreateCategory from "./pages/CreateCategory";
import LwwCategories from "./pages/Parks";
import YachtClub from "./pages/YachtClub";
import BerthTariff from "./pages/BerthTariff";
import YachtClubViewDetails from "./pages/YachtClubViewDetails";
import ParkingLayout from "./pages/ParkingLayout";
import { YachtContext } from "./contexts/YachtContext";
import YCViewAddServiceDetails from "./pages/YCViewAddServiceDetails/index";
import ManageParks from "./pages/ManageParks";
import AddPark from "./pages/AddPark";
import Promotion from "./pages/Promotion";
import ManagePromotion from "./pages/ManagePromotion";
import AquaZone from "./pages/AquaZone";
import PrivilegeAccount from "./pages/PrivilegeAccounts";
import ManagePrivilegeAccount from "./pages/ManagePrivilegeAccounts";
import LWWTicket from "./pages/LwwTickets";
import { decryptItem } from "./utils";
import RegisterAMDMembership from "./pages/RegisterAMDMembership";
import PrecisionPricing from "./pages/PrecisionPricing";

const App = () => {
  const [user, setUser] = useState<string | null | number>();
  const [loading, setLoader] = useState(false);
  const [berthID, setBerthID] = useState("");
  const [status, setStatus] = useState(navigator.onLine);

  useEffect(() => {
    function changeStatus() {
      setStatus(navigator.onLine);
    }
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  useEffect(() => {
    if (!status) {
      // no network connection
      toast.error(
        <ToastMessage
          message="You're offline now"
          subMessage="Oops! Internet is disconnected."
        />,
        {
          hideProgressBar: true,
        }
      );
    }
  }, [status]);

  useEffect(() => {
    let { user: roleId } = decryptItem();
    setUser(roleId || 0);
  }, []);

  return (
    <LoadContext.Provider value={{ loading, setLoader }}>
      <UserContext.Provider value={{ user, setUser }}>
        <YachtContext.Provider value={{ berthID, setBerthID }}>
          {loading && <Loader />}
          <Routes>
            <Route path="auth" element={<Auth />}>
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Login />} />
              <Route index element={<Navigate to="login" replace={true} />} />
            </Route>
            {Number(user) === 1 && (
              <Route path="admin" element={<Dashboard />}>
                <Route path="dashboard" element={<Home />} />
                <Route path="customer" element={<Customer />} />
                <Route path="merchant" element={<Merchant />} />
                <Route path="add-merchant" element={<ManageMerchant />} />
                <Route path="edit-merchant/:id" element={<ManageMerchant />} />
                <Route path="settings" element={<EntryAccess />} />
                <Route path="physical-card" element={<PhysicalCard />} />
                <Route
                  path="topup-transactions"
                  element={<TopUpTransactions />}
                />
                <Route path="report" element={<Report />} />
                <Route path="report/:id" element={<ReportMerchant />} />
                <Route
                  path="push-notification"
                  element={<PushNotification />}
                />
                <Route path="dispute" element={<Dispute />} />
                <Route path="events" element={<Events />} />
                <Route path="create-event" element={<CreateEvent />} />
                <Route path="edit-event/:id" element={<CreateEvent />} />
                <Route path="manage-outlet" element={<ManageOutlet />} />
                <Route path="add-outlet" element={<AddOutlet />} />
                <Route path="edit-outlet/:id" element={<AddOutlet />} />
                <Route path="amd-membership" element={<AlMahaDrive />} />
                <Route
                  path="register-membership"
                  element={<RegisterAMDMembership />}
                />
                <Route path="create-product" element={<CreateCategory />} />
                <Route path="edit-product/:id" element={<CreateCategory />} />
                {/* <Route path="lusail-winter-wonderland" element={<LwwCategories />} /> */}
                <Route path="yacht-club" element={<YachtClub />} />
                <Route path="berth-tariff" element={<BerthTariff />} />
                <Route path="parking-layout" element={<ParkingLayout />} />
                <Route path="layout" element={<ParkingLayout />} />
                <Route
                  path="view-details/:id"
                  element={<YachtClubViewDetails />}
                />
                <Route
                  path="view-adddetails/:id"
                  element={<YCViewAddServiceDetails />}
                />
                <Route path="manage-parks" element={<ManageParks />} />
                <Route path="add-park" element={<AddPark />} />
                <Route path="edit-park/:id" element={<AddPark />} />
                <Route path="promotion" element={<Promotion />} />
                <Route path="create-promo" element={<ManagePromotion />} />
                <Route path="edit-promo/:id" element={<ManagePromotion />} />
                <Route path="manage-parks/:id" element={<LwwCategories />} />
                <Route
                  path="special-day-pricing"
                  element={<PrecisionPricing />}
                />

                <Route path="aqua" element={<AquaZone />} />
                <Route path="lww-ticket" element={<LWWTicket />} />
                <Route
                  path="privilege-account"
                  element={<PrivilegeAccount />}
                />
                <Route
                  path="add-privilege-account"
                  element={<ManagePrivilegeAccount />}
                />
                <Route
                  path="edit-privilege-account/:id"
                  element={<ManagePrivilegeAccount />}
                />
                <Route
                  index
                  element={<Navigate to="dashboard" replace={true} />}
                />
              </Route>
            )}
            {Number(user) === 2 && (
              <Route path="admin" element={<Dashboard />}>
                <Route path="physical-card" element={<PhysicalCard />} />
                <Route
                  index
                  element={<Navigate to="physical-card" replace={true} />}
                />
              </Route>
            )}
            {Number(user) === 3 && (
              <Route path="admin" element={<Dashboard />}>
                <Route path="dispute" element={<Dispute />} />
                <Route path="report" element={<Report />} />
                <Route path="report/:id" element={<ReportMerchant />} />
                <Route
                  index
                  element={<Navigate to="dispute" replace={true} />}
                />
              </Route>
            )}
            {Number(user) === 4 && (
              <Route path="admin" element={<Dashboard />}>
                <Route
                  path="push-notification"
                  element={<PushNotification />}
                />
                <Route path="events" element={<Events />} />
                <Route path="create-event" element={<CreateEvent />} />
                <Route path="edit-event/:id" element={<CreateEvent />} />
                <Route path="amd-membership" element={<AlMahaDrive />} />
                <Route path="manage-parks/:id" element={<LwwCategories />} />
                <Route
                  path="special-day-pricing"
                  element={<PrecisionPricing />}
                />
                <Route path="create-product" element={<CreateCategory />} />
                <Route path="edit-product/:id" element={<CreateCategory />} />
                <Route path="manage-parks" element={<ManageParks />} />
                <Route path="add-park" element={<AddPark />} />
                <Route path="edit-park/:id" element={<AddPark />} />
                <Route path="promotion" element={<Promotion />} />
                <Route path="create-promo" element={<ManagePromotion />} />
                <Route path="edit-promo/:id" element={<ManagePromotion />} />
                <Route path="manage-parks/:id" element={<LwwCategories />} />
                <Route
                  path="register-membership"
                  element={<RegisterAMDMembership />}
                />
                <Route
                  index
                  element={<Navigate to="push-notification" replace={true} />}
                />
              </Route>
            )}
            {Number(user) === 5 && (
              <Route path="admin" element={<Dashboard />}>
                <Route path="aqua" element={<AquaZone />} />
                <Route index element={<Navigate to="aqua" replace={true} />} />
              </Route>
            )}
            {Number(user) === 6 && (
              <Route path="admin" element={<Dashboard />}>
                <Route path="lww-ticket" element={<LWWTicket />} />
                <Route
                  index
                  element={<Navigate to="lww-ticket" replace={true} />}
                />
              </Route>
            )}
            <Route index element={<Navigate to={"auth"} replace={true} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </YachtContext.Provider>
      </UserContext.Provider>
    </LoadContext.Provider>
  );
};

export default App;
